/**
 * AccountSignOut.jsx
 * Created by Michael Bray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import CartIndicator from '../../sharedComponents/CartIndicator';
import AccountProfileDropdown from './AccountProfileDropdown';

import { ACCOUNT_PROPS, CART_HEADER_PROPS } from '../constants';

export default class AccountSignOut extends React.PureComponent {
    static propTypes = {
        cart: CART_HEADER_PROPS,
        account: ACCOUNT_PROPS,
        logout: PropTypes.func,
        isGuest: PropTypes.bool,
        openLoginModal: PropTypes.func
    };

    render() {

        return (
            <div className="nav-user-actions">
                <CartIndicator cart={this.props.cart} />
                <AccountProfileDropdown
                    account={this.props.account}
                    isGuest={this.props.isGuest}
                    openLoginModal={this.props.openLoginModal}
                    signOut={this.props.logout} />
            </div>
        );
    }
}
